import React from "react";
import { Grid } from "@material-ui/core";
import "../../css/projects.css";

function PastWorkCard(props) {
    return (
        <div className="pastWorkCard">
            <Grid container>
                <Grid item container justify="center" xs={12}>
                    <img className="pastWorkCardImage" src={props.logo} alt="Company Logo" />
                </Grid>

                <Grid item container xs={1}></Grid>
                <Grid item container xs={10}>
                    <p className="pastWorkCard-companyName">{props.companyName}</p>
                </Grid>
                <Grid container item xs={1}></Grid>

                <Grid item container xs={1}></Grid>
                <Grid item container xs={10}>
                    <p className="pastWorkCard-description">{props.projectDescription}</p>
                </Grid>
                <Grid container item xs={1}></Grid>
            </Grid>
        </div>
    );
}

export default PastWorkCard;